module.exports = __webpack_public_path__ + "img/settings.d47848aa.png";